import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ModalFooter } from 'syf-component-library/ui/patterns/SlideInModal';
import { FooterContainer } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents';
import { Inset } from 'syf-component-library/ui/spacing';
import { useAccountActivity } from '../../../../api/accountActivity';
import { DATA_OBJECT, DATA_TYPE } from '../../../../const/analytics';
import { paymentTypes } from '../../../../const/paymentOptions';
import useApiMachine from '../../../../hooks/machines/useApiMachine';
import useFormValues from '../../../../hooks/machines/useFormValues';
import usePaymentFlowMachine from '../../../../hooks/machines/usePaymentFlowMachine';
import { t } from '../../../../strings/i18n';
import IntroHeading from '../../../../ui/atoms/IntroHeading';
import PageLevelError from '../../../../ui/atoms/PageLevelError';
import { PaymentModalWrapper } from '../../../../ui/atoms/styled';
import { useXForm, XForm } from '../../../../xform';
import { getHasMatchingPayment } from '../helpers';
import { PaymentMethodSelect, PaymentTypeSelect, PayoffAmountDateSelect } from '../PaymentFormSubcomponents';
import PaymentStepper from '../PaymentFormSubcomponents/PaymentStepper';
const Form = () => {
    const { submit } = useXForm();
    const handleSubmit = (e) => {
        e.preventDefault();
        submit();
    };
    return (_jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(PaymentTypeSelect, { value: paymentTypes.PAYOFF }), _jsx(PayoffAmountDateSelect, {}), _jsx(PaymentMethodSelect, { id: "paymentMethod" }), _jsx("input", { "aria-hidden": true, "data-testid": "submit-button", style: { display: 'none' }, type: "submit" })] })));
};
const PayoffPaymentForm = () => {
    const [{ data: activityResp }] = useAccountActivity();
    const [apiMachine] = useApiMachine();
    const { autopayStatusQueryResult } = apiMachine.context;
    const { data: autopayStatus } = autopayStatusQueryResult;
    const [, payoffPaymentActor, sendToPayoffMachine] = usePaymentFlowMachine();
    const formMachine = payoffPaymentActor.context.form;
    const payoffPaymentForm = useFormValues();
    const { paymentMethod, paymentDate } = payoffPaymentForm;
    const activity = activityResp.activity || [];
    const isAutopayEnrolled = autopayStatus.enrollment;
    const hasMatchingPayment = getHasMatchingPayment(paymentDate, paymentMethod, activity);
    const submitHandler = async () => {
        /*
         * Normally, the submit button would be nested as a child of the `<form />`.
         * But our UI has it outside of the form element so we have to use the native
         * machine API to send the submit event
         */
        formMachine.send({
            type: 'SUBMIT'
        });
    };
    const onSubmitHandler = () => {
        sendToPayoffMachine({ type: 'NEXT' });
    };
    const handleCancel = () => {
        sendToPayoffMachine({ type: 'CANCEL' });
    };
    return (_jsxs(_Fragment, { children: [_jsx(PaymentStepper, { step: "details" }), _jsx(Inset, Object.assign({ bottom: "small", top: "large", vertical: "large" }, { children: _jsxs(IntroHeading, { children: [isAutopayEnrolled
                            ? `${t('makePayment.makePaymentAutopayOnInstruction')}`
                            : `${t('makePayment.makePaymentInstruction')}`, ' ', t('label.allFieldRequiredInstruction')] }) })), hasMatchingPayment && (_jsx(Inset, Object.assign({ bottom: "large", vertical: "large" }, { children: _jsx(PageLevelError, { errorMessage: t('errors.matchingPaymentDate') }) }))), _jsx(PaymentModalWrapper, Object.assign({ bottom: "xlarge", vertical: "large" }, { children: _jsx(XForm, Object.assign({ formMachine: formMachine, submit: submitHandler, onSubmit: onSubmitHandler }, { children: _jsx(Form, {}) })) })), _jsx(FooterContainer, { children: _jsx(ModalFooter, { dataCy: "payment-form-footer", dataPrimaryObject: DATA_OBJECT.BUTTON, dataPrimaryReason: "next", dataSecondaryObject: DATA_OBJECT.BUTTON, dataSecondaryReason: "cancel", dataType: DATA_TYPE.MAKE_A_PAYMENT, handlePrimaryButton: submitHandler, handleSecondaryButton: handleCancel, primaryText: t('button.next'), secondaryButtonType: "ghost", secondaryText: t('button.cancel') }) })] }));
};
export default PayoffPaymentForm;
